import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "M-Auto color1" }
const _hoisted_3 = {
  key: 0,
  class: "H-100 P-Abs D-Flex",
  style: {"width":"2em","inset-inline-end":"0","top":"0","z-index":"500"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "DialogShade" }, null, -1)
const _hoisted_5 = {
  class: "Shadow1 D-Flex M-Auto CookiesFade",
  style: {"max-height":"100vh","overflow":"scroll"}
}
const _hoisted_6 = { class: "DialogBase" }
const _hoisted_7 = { class: "CookiesDialogHeader F-Bold F-S4 O-75" }
const _hoisted_8 = { class: "M-Auto color1" }
const _hoisted_9 = { style: {"min-height":"10vh"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.CurrentDialogs.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$store.state.Printing !== '' && 'PrintingHider')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CurrentDialogs, (Dialog, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: (index),
              class: "DialogPlaceHolder color3"
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (Dialog.Options && !Dialog.Options.NoBackgroundClose && _ctx.$router.go(-1)),
                class: "DialogShade"
              }, null, 8, _hoisted_1),
              _createElementVNode("div", {
                class: _normalizeClass(["Shadow1 D-Flex M-Auto CookiesFade", _ctx.FullWindowChecker(Dialog.Options) ? 'FullWindowDialog': '']),
                style: {"max-height":"100vh","overflow-y":"scroll","flex-direction":"column"}
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["DialogBase", _ctx.FullWindowChecker(Dialog.Options) ? 'FullWindowDialog': '']),
                  style: _normalizeStyle('background: ' + _ctx.BackgroundChecker(Dialog.Options))
                }, [
                  (_ctx.HeaderChecker(Dialog.Options))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "CookiesDialogHeader P-Rel F-Bold O-75",
                        style: _normalizeStyle('background: ' + _ctx.BackgroundChecker(Dialog.Options))
                      }, [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(Dialog.Name), 1),
                        (!Dialog.Options?.NoHeaderClose)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_CookiesIcon, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
                                class: "V-Auto SQR1em Pointer",
                                ID: ('Close' as IconsIDs)
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ], 4))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    style: {"min-height":"10vh"},
                    class: _normalizeClass(_ctx.FullWindowChecker(Dialog.Options) ? 'FullWindowDialog': '')
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Dialog.Content), {
                      DialogIndex: Dialog.Num,
                      DialogData: Dialog.Data
                    }, null, 8, ["DialogIndex", "DialogData"]))
                  ], 2)
                ], 6)
              ], 2)
            ]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.ErrorDialogs.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.$store.state.Printing !== '' && 'PrintingHider')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ErrorDialogs, (Dialog, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: (index),
              class: "DialogPlaceHolder"
            }, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(Dialog.Name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Dialog.Content), {
                      DialogIndex: index,
                      DialogData: Dialog.Data
                    }, null, 8, ["DialogIndex", "DialogData"]))
                  ])
                ])
              ])
            ]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}